module.exports = __webpack_public_path__ + "img/IMG_6992.35cd32b5.webp";